import { OPEN_MEGAMENU } from 'redux/modules/mega-menu/actions/types';

export default () => ({
  type: OPEN_MEGAMENU,
});
